export const KVKKMenuItems = [
    {
        name: {
            tr: 'MÜŞTERİ VE ZİYARETÇİ AYDINLATMA METNİ',
            en: 'KVKK PERSONAL DATA PROTECTION AUTHORITY',
        },
        slug: {
            en: '/privacy-policy',
            tr: '/aydinlatma-metni',
        },
    },
    {
        name: { tr: 'ÇEREZ POLİTİKASI', en: 'COOKIE POLICY' },
        slug: {
            en: '/cookie-policy',
            tr: '/cerez-politikasi',
        },
    },
    {
        name: {
            tr: 'SAKLAMA VE İMHA POLİTİKASI',
            en: 'DATA STORAGE AND DESTROY',
        },
        slug: {
            en: '/storage-and-destroy',
            tr: '/saklama-ve-imha-politikasi',
        },
    },
    {
        name: {
            tr: 'İLGİLİ KİŞİ BAŞVURU FORMU',
            en: 'RELATED PERSON APPLICATION FORM',
        },
        slug: {
            en: '/application-form',
            tr: '/ilgili-kisi-basvuru-formu',
        },
    },
];
export const RightsandAssignmentsMenuItems = [
    {
        name: {
            tr: 'ÜYELİK ÖN BİLGİLENDİRME',
            en: 'MEMBERSHIP INFORMATIONS',
        },
        slug: {
            en: '/membership-info',
            tr: '/uyelik-on-bilgilendirme',
        },
    },
    {
        name: { tr: 'ÜYELİK SÖZLEŞMESİ', en: 'MEMBERSHİP AGREEMENT' },
        slug: {
            en: '/membership-agreement',
            tr: '/uyelik-sozlesmesi',
        },
    },
    {
        name: {
            tr: 'MESAFELİ SATIŞ SÖZLEŞMESİ',
            en: 'PRELIMINARY INFORMATION FORM',
        },
        slug: {
            en: '/distance-sale-contract',
            tr: '/mesafeli-satis-sozlesmesi',
        },
    },
    {
        name: {
            tr: 'MESAFELİ SATIŞ ÖN BİLGİLENDİRME',
            en: 'DISTANCE SELLING AGREEMENT INFORMING',
        },
        slug: {
            en: '/distance-sale-contract-information',
            tr: '/mesafeli-satis-on-bilgilendirme',
        },
    },
    {
        name: {
            tr: 'TESLİM, CAYMA, İPTAL VE İADE KOŞULLARI',
            en: 'DELIVERY, WITHDRAWAL, CANCELLATION AND REFUND CONDITIONS',
        },
        slug: {
            en: '/change-and-return',
            tr: '/degisim-ve-iade',
        },
    },
];
